import { SignJWT } from 'jose';

export default function JtokenRequest(payload, key) {
    const chave = new TextEncoder().encode(key);

    return new SignJWT({ codUsuario: payload })
        .setProtectedHeader({ alg: 'HS256' })
        .setExpirationTime('15m')
        .sign(chave)
        .then(token => {
            return token;
        })
        .catch(error => {
            return null;
        });
}
